import { priceTypeService } from '@services';

class PriceTypeController {
  getAll = async (cancelSignal, setStatuses) => {
    try {
      const result = await priceTypeService.getAll(cancelSignal);

      if (result.success) {
        setStatuses(result.data);
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Cancelled request');
      }
    }
  };
}

export default PriceTypeController;
